import api from './api'

const userService = {}

userService.create = payload => api.post('/users/trial', payload)

export default userService
